import { TMessageSchema, TMessagesMap } from '../../types/messages';
import { ERequestApiStatus } from '../../types/appState';
import { TOpenedChats } from '../../types/openedChats';
import { updateMessagesInChat } from './updateMessagesInChat';

interface IAddMessagesToChatParams {
  openedChats: TOpenedChats;
  messages: TMessageSchema[];
  chatId?: string;
  userId: number;
  messagesMap: TMessagesMap;
  checkRowVersion?: boolean;
  markAllMessagesLoaded?: boolean;
}

/** Добавляет сообщения в открытый чат и обновляет его состояние. */
export const addMessagesToChat = ({
  openedChats,
  messages,
  chatId,
  userId,
  messagesMap,
  checkRowVersion = false,
  markAllMessagesLoaded = false,
}: IAddMessagesToChatParams): TOpenedChats => {
  const currentChat = chatId ? openedChats[chatId] : null;

  if (!chatId || !currentChat) {
    return openedChats;
  }

  if (!messages.length) {
    return {
      ...openedChats,
      [chatId]: {
        ...currentChat,
        ...(markAllMessagesLoaded ? { allMessagesLoaded: true } : {}),
        status: ERequestApiStatus.Succeed,
      },
    };
  }

  const chatMessages = updateMessagesInChat({
    messagesMap,
    rawMessages: messages,
    chatMessages: currentChat.chatMessages,
    userId,
    status: undefined,
    checkRowVersion,
  });

  return {
    ...openedChats,
    [chatId]: {
      ...currentChat,
      currentTimestamp: chatMessages[0]?.message.created,
      chatMessages,
      status: ERequestApiStatus.Succeed,
    },
  };
};
